import axios from 'axios';
import { authService } from 'Utils/AuthService';
import type { AudioRecCalibrationProfile } from '../types';
import { sanitizeCalibrationProfile } from '../calibration/profile';

type StoredUserAudioRecProfile = {
  profile?: unknown;
};

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const baseUrl = backendUrl ? `${backendUrl}/api/v1/user-audio-rec-profiles` : null;

// The axios interceptor attaches auth; we only skip calls when logged out.
const isApiAuthenticated = () => authService.getSnapshot().status === 'authenticated';

export const fetchActiveCalibrationProfileFromApi =
  async (): Promise<AudioRecCalibrationProfile | null> => {
    if (!baseUrl || !isApiAuthenticated()) return null;

    try {
      const response = await axios.get<StoredUserAudioRecProfile | null>(`${baseUrl}/active`);
      const rawProfile = response.data?.profile;
      return sanitizeCalibrationProfile(rawProfile ?? null);
    } catch {
      return null;
    }
  };

export const saveCalibrationProfileToApi = async (
  profile: AudioRecCalibrationProfile,
): Promise<void> => {
  if (!baseUrl || !isApiAuthenticated()) return;

  try {
    await axios.post(baseUrl, {
      label: profile.label,
      profile,
    });
  } catch (error) {
    console.warn('[AudioRecognition] Failed to save calibration profile to API.', error);
  }
};

export const clearActiveCalibrationProfileFromApi = async (): Promise<void> => {
  if (!baseUrl || !isApiAuthenticated()) return;

  try {
    await axios.delete(`${baseUrl}/active`);
  } catch (error) {
    console.warn('[AudioRecognition] Failed to clear active calibration profile from API.', error);
  }
};
